import type { TargetCapabilities } from '../catalog/target.interface.js';

export const projectCapabilities: TargetCapabilities = {
  rules: 'native',
  additionalRules: 'none',
  commands: 'none',
  agents: 'native',
  skills: 'none',
  mcp: 'native',
  hooks: 'none',
  ignore: 'none',
  permissions: 'none',
};

export const globalCapabilities: TargetCapabilities = {
  rules: 'native',
  additionalRules: 'none',
  commands: 'none',
  agents: 'native',
  skills: 'none',
  mcp: 'native',
  hooks: 'none',
  ignore: 'none',
  permissions: 'none',
};
